import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["shareDiv"];

  toggleShare() {
    this.shareDivTarget.classList.toggle("hidden");
  }

  closeShare() {
    this.shareDivTarget.classList.add("hidden");
  }

  shareAction(event) {
    const action = event.currentTarget.dataset.shareAction;
    console.log(`Share on ${action}`);
  }

  popupCenter(url, width, height, windowName) {
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    window.open(url, windowName, `width=${width},height=${height},top=${top},left=${left}`);
  }

  getMessage() {
    return "Check out this property I found on HistoricStays101!";
  }

  shareOnFacebook(event) {
    event.preventDefault();
    const currentUrl = window.location.href;
    this.popupCenter(`https://www.facebook.com/sharer.php?u=${currentUrl}`, 600, 400, "authPopup");
  }

  shareOnTwitter(event) {
    event.preventDefault();
    const currentUrl = window.location.href;
    const title = this.getMessage();
    this.popupCenter(
      encodeURI(`https://x.com/intent/tweet?text=${title}&url=${currentUrl}`),
      600,
      400,
      "authPopup"
    );
  }

  shareOnWhatsApp(event) {
    event.preventDefault();
    const currentUrl = window.location.href;
    const title = this.getMessage();
    this.popupCenter(
      `https://api.whatsapp.com/send/?text=${title}. ${encodeURIComponent(currentUrl)}`,
      600,
      400,
      "authPopup"
    );
  }

  shareOnLinkedIn(event) {
    event.preventDefault();
    const currentUrl = window.location.href;
    this.popupCenter(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`,
      600,
      400,
      "authPopup"
    );
  }
}
